export function pluralize(config: {
  singular: string;
  plural: string;
  count: number;
}): string {
  return config.count === 1 ? config.singular : config.plural;
}
